import { Head } from 'features/head'

export const NotFoundPage = () => (
  <>
    <Head title='404: Not found' />
    404: Not Found
  </>
)
